class ProductSliderSwiper extends HTMLElement {
  /** @type {import('swiper').Swiper | undefined} */
  #swiper;
  #mediaQuery = window.matchMedia('(min-width: 750px)');
  #onMediaChange = () => this.#updateMode();

  connectedCallback() {
    this.#mediaQuery.addEventListener('change', this.#onMediaChange);
    this.#updateMode();
  }

  disconnectedCallback() {
    this.#mediaQuery.removeEventListener('change', this.#onMediaChange);
    this.#destroySwiper();
  }

  #updateMode() {
    if (this.#mediaQuery.matches) {
      this.classList.remove('is-mobile-scroll');
      this.#initSwiper();
    } else {
      this.#destroySwiper();
      this.classList.add('is-mobile-scroll');
    }
  }

  #destroySwiper() {
    this.#swiper?.destroy(true, true);
    this.#swiper = undefined;
  }

  #initSwiper() {
    if (this.#swiper) return;

    const container = this.querySelector('.swiper');
    if (!container || typeof Swiper === 'undefined') return;

    const showPagination = this.dataset.pagination === 'true';
    const showNavigation = this.dataset.navigation === 'true';
    const showScrollbar = this.dataset.scrollbar === 'true';
    const autoplayDelay = parseInt(this.dataset.autoplayDelay, 10);
    const slidesMobile = parseFloat(this.dataset.slidesMobile) || 1;
    const slidesTablet = parseFloat(this.dataset.slidesTablet) || 2;
    const slidesDesktop = parseFloat(this.dataset.slidesDesktop) || 3;
    const slideCount = container.querySelectorAll('.swiper-slide').length;
    const maxSlidesPerView = Math.max(slidesMobile, slidesTablet, slidesDesktop);
    const enableLoop = this.dataset.loop === 'true' && slideCount > maxSlidesPerView;

    /** @type {import('swiper').SwiperOptions} */
    const config = {
      direction: this.dataset.direction === 'vertical' ? 'vertical' : 'horizontal',
      loop: enableLoop,
      slidesPerView: slidesTablet,
      spaceBetween: parseInt(this.dataset.spaceBetween, 10) || 20,
      speed: parseInt(this.dataset.speed, 10) || 400,
      noSwipingClass: 'swiper-no-swiping',
      preventClicks: false,
      preventClicksPropagation: false,
      breakpoints: {
        990: {
          slidesPerView: slidesDesktop,
        },
      },
    };

    if (showPagination) {
      const el = this.querySelector('.swiper-pagination');
      if (el) {
        config.pagination = { el, clickable: true };
      }
    }

    if (showNavigation) {
      const nextEl = this.querySelector('.swiper-button-next');
      const prevEl = this.querySelector('.swiper-button-prev');
      if (nextEl && prevEl) {
        config.navigation = { nextEl, prevEl };
      }
    }

    if (showScrollbar) {
      const el = this.querySelector('.swiper-scrollbar');
      if (el) {
        config.scrollbar = { el, draggable: true };
      }
    }

    if (autoplayDelay > 0) {
      config.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    this.#swiper = new Swiper(container, config);
  }
}

if (!customElements.get('product-slider-swiper')) {
  customElements.define('product-slider-swiper', ProductSliderSwiper);
}
